import { PiArrowUpLight } from 'react-icons/pi';
import { useCallback, useEffect, useState } from 'react';
import './ScrollToTop.css';

export function ScrollToTop() {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function onScroll() {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? scrollTop / docHeight : 0;
      setProgress(pct);
      setVisible(scrollTop > 300);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  // SVG circle math — radius 20, circumference ≈ 125.66
  const radius = 20;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - progress);

  return (
    <button
      className={`scroll-to-top ${visible ? 'visible' : ''}`}
      onClick={scrollToTop}
      aria-label="Scroll to top"
      title={`${Math.round(progress * 100)}% scrolled — back to top`}
    >
      {/* Progress ring */}
      <svg className="progress-ring" viewBox="0 0 48 48" aria-hidden="true">
        {/* Track */}
        <circle
          cx="24"
          cy="24"
          r={radius}
          fill="none"
          className="progress-track"
          strokeWidth="1.5"
        />
        {/* Progress arc */}
        <circle
          cx="24"
          cy="24"
          r={radius}
          fill="none"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className="progress-arc"
        />
      </svg>

      <PiArrowUpLight className="terminal-icon" aria-hidden="true" />
    </button>
  );
}
